import React, { useState } from 'react';
import SittingManPlant from './assets/sittingManPlant.svg';
import { ButtonWithLoader } from 'components/reusable/button-loader';
import { useGlobalState } from 'store/reducers/reducer';
import { resendVerification } from 'store/sagas/sagas';
import './verification-page.css';
export const VerificationPage = () => {
    const { state, asyncDispatch } = useGlobalState();
    const user = {
        ...state.user
    };
    const [showVerify, setShowVerify] = useState(true);
    const handleVerifyEmail = () => {
        if (state.user?.email) {
            asyncDispatch(resendVerification(state.user.email))
                .then(() => {
                setShowVerify(false);
            })
                .catch(console.error);
        }
    };
    return (React.createElement("div", { className: "verify-container" },
        React.createElement("h1", null, "Thanks for creating a Vouched account!"),
        React.createElement(SittingManPlant, { className: "verify-graphic", display: "block", fill: "none", height: "auto", role: "img", viewBox: "0 0 322 356", width: "322" }),
        React.createElement("p", { className: "verify-text top-text" }, "We have sent you a verification email. Please check your inbox!"),
        React.createElement("p", { className: "verify-text bottom-text" }, "If you cannot see the verification email after checking all folders in your inbox, click the \"Resend\" button to have another email sent."),
        !user.emailVerified && showVerify && (React.createElement(ButtonWithLoader, { disabled: false, isLoading: false, name: "Resend", onClick: handleVerifyEmail }))));
};
